import { render, staticRenderFns } from "./DeductionTypeDialog.vue?vue&type=template&id=3efb8404"
import script from "./DeductionTypeDialog.vue?vue&type=script&lang=js"
export * from "./DeductionTypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports